/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Review } from './Review';
import {
    ReviewFromJSON,
    ReviewFromJSONTyped,
    ReviewToJSON,
} from './Review';

/**
 * 
 * @export
 * @interface GetReviews200ResponseAllOfData
 */
export interface GetReviews200ResponseAllOfData {
    /**
     * 
     * @type {Array<Review>}
     * @memberof GetReviews200ResponseAllOfData
     */
    reviews: Array<Review>;
}

/**
 * Check if a given object implements the GetReviews200ResponseAllOfData interface.
 */
export function instanceOfGetReviews200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "reviews" in value;

    return isInstance;
}

export function GetReviews200ResponseAllOfDataFromJSON(json: any): GetReviews200ResponseAllOfData {
    return GetReviews200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetReviews200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReviews200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reviews': ((json['reviews'] as Array<any>).map(ReviewFromJSON)),
    };
}

export function GetReviews200ResponseAllOfDataToJSON(value?: GetReviews200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reviews': ((value.reviews as Array<any>).map(ReviewToJSON)),
    };
}

